import React from 'react';
import Modal from '../../../components/common/Modal';
import Button from '../../../components/common/Button';

interface OneDriveModalProps {
    isOpen: boolean;
    onClose: () => void;
    data: any[];
    isLoading: boolean;
    error: string | null;
}

const OneDriveModal: React.FC<OneDriveModalProps> = ({ isOpen, onClose, data, isLoading, error }) => (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
        <Modal.Header>OneDrive Excel Data (Sheet: IV)</Modal.Header>
        <Modal.Body>
            {isLoading && <div className="loading-spinner">Loading...</div>}
            {error && <div className="error-message">{error}</div>}
            {!isLoading && !error && data.length === 0 && (
                <p>No data found in sheet "IV".</p>
            )}
            {!isLoading && !error && data.length > 0 && (
                <div className="table-container">
                    <table className="data-table">
                        <thead>
                            <tr>
                                {Object.keys(data[0]).map((key) => (
                                    <th key={key}>{key}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((row, index) => (
                                <tr key={index}>
                                    {Object.values(row).map((value: any, i) => (
                                        <td key={i}>{String(value)}</td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </Modal.Body>
        <Modal.Footer>
            <Button variant="outline" type="button" onClick={onClose} data-testid="BTN_onedrive_close">Close</Button>
        </Modal.Footer>
    </Modal>
);

export default OneDriveModal;
